import React, { Component } from 'react'
import $ from 'jquery';
import slugify from 'slugify';
import qs from 'qs';
import { Col, Row } from 'reactstrap';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import ComplianceCard from '../compliance/components/compliance-card'
//import Control from '../compliance/controlGrid';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import ControlTable from './ControlTable'

class LowLevelCategories extends Component {
    state = {
        categories: [],
        controls: [],
        loading: true,
        loaded: false,
        totalControls: 0,
        compliantControlsTotal: 0,
        selectedCategory: 0,
        scrolling: false,
        updateGrid: true,
        urlFrameworkName: null,
        highLevelCategory: null,
        humanHighLevelCategory: '',
        lowLevelCategory: null,
        isFlat: null,
        categoryCompliance: 0
    }

    signoutUser() {
        this.props.signout();
        this.props.history.push('/');
    }

    setUpdate = (title, active) => {
        this.setState({ updateGrid: (title !== active) })
    }

    selectNewCatagory(category, lowLevelCategory) {
        this.setState({ selectedCategory: category, lowLevelCategory: lowLevelCategory });
    }

    scrollContent(direction) {
        const step = 370;

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
        });
    }

    getCatInView(i) {
        const step = 370;
        let direction = 'right';

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step * i + "px"
        });
    }

    renderSlideCards() {
        return this.state.categories.map((category, i) => {
            let percentageCal = (category.numberOfControls - category.numberOfNotApplicableControls) > 0 ?
                Number((category.numberOfCompliantControls /
                    (category.numberOfControls - category.numberOfNotApplicableControls) * 100).toFixed(0)) : 0;

            return <div key={category.name} style={{ marginRight: 20 }}>
                <ComplianceCard
                    id={i}
                    category={category.name}
                    percentage={false}
                    changeCategory={this.selectNewCatagory.bind(this)}
                    numberCompliance={category.numberOfCompliantControls}
                    totalControls={category.numberOfControls - category.numberOfNotApplicableControls}
                    clickable={true}
                    percentage_color={percentageCal > 0 ? "#2d9aa6" : "#C6C6C6"} //#3DA3FC
                    hoverColor={true}
                    isActive={this.state.selectedCategory === i ? true : false}
                    setUpdate={this.setUpdate}
                    bgColor="white-bg"
                    selectedCatName={this.state.categories[this.state.selectedCategory]}
                    isPercentage={false}
                />
            </div>
        })
    }

    componentDidMount() {
        const { categories, highLevelCategory } = this.props;
        let selectedHighLevelCategory = null
        let selectedCategory = 0
        let pageData = {
            categories: categories,
        }

        if (highLevelCategory) {
            selectedHighLevelCategory = categories.find(c => slugify(c.name.toLowerCase()) === highLevelCategory);
            if (selectedHighLevelCategory) {

                //we redefine the page data to be the specific category
                let sortedCategories = selectedHighLevelCategory.categories.slice(0)
                try {
                    sortedCategories.sort((a, b) => {
                        if (a.lowLevelOrder && b.lowLevelOrder) {
                            return Number(a.lowLevelOrder) - Number(b.lowLevelOrder)
                        }
                        else {
                            return 0
                        }
                    })
                } catch (err) {
                }
                pageData.categories = sortedCategories
                pageData.totalControls =
                    selectedHighLevelCategory.numberOfControls - selectedHighLevelCategory.numberOfNotApplicableControls
                pageData.notApplicableControlsTotal = selectedHighLevelCategory.numberOfNotApplicableControls || 0
            }
        } else {
            pageData.totalControls =
                categories.reduce((prevNumberOfControls, currentCategory) =>
                    prevNumberOfControls +
                    (currentCategory.numberOfControls - currentCategory.numberOfNotApplicableControls), 0)
            pageData.compliantControlsTotal =
                categories.reduce((prevNumberOfCompliantControls, currentCategory) =>
                    prevNumberOfCompliantControls + currentCategory.numberOfCompliantControls, 0)
            pageData.notApplicableControlsTotal =
                categories.reduce((prevNumberOfNotApplicableControls, currentCategory) =>
                    prevNumberOfNotApplicableControls + currentCategory.numberOfNotApplicableControls, 0)
        }

        //scrolls to url category
        try {
            const parsed = qs.parse(this.props.location.search.slice(1));

            if (parsed && parsed.category) {
                pageData.categories.map((category, i) => {
                    let slugifiedCatName = slugify(category.name).toLowerCase();

                    if (String(parsed.category).toLowerCase() === slugifiedCatName) {
                        selectedCategory = i
                        this.getCatInView(i)
                    }
                    return 0;
                });
            }
        }
        catch (err) {
        }

        this.setState({
            categories: pageData.categories.slice(0),
            highLevelCategory: highLevelCategory ? highLevelCategory : '',
            humanHighLevelCategory: selectedHighLevelCategory ? selectedHighLevelCategory.name : '',
            lowLevelCategory: pageData.categories[selectedCategory].name.toLowerCase(),
            isFlat: !highLevelCategory,
            selectedCategory: selectedCategory,
            loading: false
        })
    }



    render() {
        const {
            loaded, loading, navigationStyle,
            categories, compliantControlsTotal, totalControls,
            frameworkName, headingDescription, highLevelCategory
        } = this.props;

        let selectedHighLevelCategory = null

        let pageData = {
            compliantControlsTotal: compliantControlsTotal,
            totalControls: totalControls,
            subHeading: headingDescription,
            title: frameworkName + ' Controls',
            notApplicableControlsTotal: 0
        }

        if (highLevelCategory) {
            selectedHighLevelCategory = categories.find(c => slugify(c.name.toLowerCase()) === highLevelCategory);
            if (selectedHighLevelCategory) {
                //we redefine the page data to be the specific category
                // pageData.categories = selectedHighLevelCategory.categories
                pageData.compliantControlsTotal = selectedHighLevelCategory.numberOfCompliantControls || 0
                pageData.notApplicableControlsTotal = selectedHighLevelCategory.numberOfNotApplicableControls || 0
                pageData.totalControls =
                    selectedHighLevelCategory.numberOfControls - selectedHighLevelCategory.numberOfNotApplicableControls
                pageData.subHeading = selectedHighLevelCategory.description
                pageData.title = selectedHighLevelCategory.name + ' Controls'

            }
        } else {
            pageData.totalControls =
                categories.reduce((prevNumberOfControls, currentCategory) =>
                    prevNumberOfControls +
                    (currentCategory.numberOfControls - currentCategory.numberOfNotApplicableControls), 0)
            pageData.compliantControlsTotal =
                categories.reduce((prevNumberOfCompliantControls, currentCategory) =>
                    prevNumberOfCompliantControls + currentCategory.numberOfCompliantControls, 0)
            pageData.notApplicableControlsTotal =
                categories.reduce((prevNumberOfNotApplicableControls, currentCategory) =>
                    prevNumberOfNotApplicableControls + currentCategory.numberOfNotApplicableControls, 0)
        }

        return (
            <div className="low-level-category">
                {/* This means the category provided in the URL is invalid */}
                {selectedHighLevelCategory === undefined ? <Redirect to='/app/dashboard' /> : null}
                <Row>
                    {(this.state.loading || !loaded || loading) &&
                        <div
                            className={`custom_load load${(this.state.loading || !loaded || loading) ?
                                '' :
                                ' loaded'}`}>
                            <div className='load__icon-wrap'>
                                <svg className='load__icon'>
                                    <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                                </svg>
                            </div>
                        </div>
                    }
                    <Col md={12} id="test">
                        <h3 className='page-title'>{pageData.title}</h3>
                        {/* <h3 className='page-subhead subhead'>{pageData.subHeading}</h3> */}
                        <h3 className='page-subhead subhead'>
                            <strong>Click a control in order to edit its help text.</strong>
                        </h3>
                    </Col>
                    <Col style={{padding:'0 50px 0 50px'}}>

                        <div style={{ display: 'flex', flexDirection: 'row' }}>

                            <div className="arrow-left" style={{ display: loading ? 'none' : 'initial' }}>
                                <div
                                    style={navigationStyle}
                                    onClick={() => this.scrollContent('left')}>
                                    <ChevronLeft id='scrollUp' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>

                            <div
                                id='card-content'
                                style={{ display: 'flex', flexDirection: 'row', overflowY: 'scroll' }}>
                                {this.renderSlideCards()}
                            </div>

                            <div className="arrow-right" style={{ display: loading ? 'none' : 'initial' }}>
                                <div
                                    style={navigationStyle}
                                    onClick={() => this.scrollContent('right')}>
                                    <ChevronRight id='scrollDown' size={60} color={'#C6C6C6'} />
                                </div>
                            </div>
                        </div>

                    </Col>
                    <ControlTable
                        categories={[this.state.categories[this.state.selectedCategory]]}
                        parse={this.props.parse}
                        frameworkId={this.props.frameworkId}
                        humanHighLevelCategory={this.state.humanHighLevelCategory}
                        lowLevelCategory={this.state.lowLevelCategory}
                        framework={this.props.urlFrameworkName}
                        isFlat={this.state.isFlat}
                        handleStatusChange={this.handleStatusChange}
                    />

                </Row>
            </div >

        )
    }
}

function mapStateToProps(state) {
    return {
        summary: state.controlsData.summary
    }
}

export default withRouter(connect(mapStateToProps)(LowLevelCategories))


// WEBPACK FOOTER //
// ./src/components/content_management/LowLevelCategories.js